import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-directionArrowsThin",
  "use": "svgIcon-directionArrowsThin-usage",
  "viewBox": "0 0 95.547 95.547",
  "content": "<symbol viewBox=\"0 0 95.547 95.547\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-directionArrowsThin\"><g><path d=\"m56.451 46.578 14.281-14.283h-63.75v-9.733h63.747l-14.276-14.281 6.303-6.305 25.453 25.455-25.451 25.451z\" fill=\"currentColor\" /><path d=\"m7.338 68.096 25.452-25.453 6.303 6.305-14.278 14.281h63.749v9.734h-63.749l14.279 14.281-6.305 6.303z\" fill=\"currentColor\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol